import { ComponentProps } from "react";

export function BusinessStory(props: ComponentProps<"svg">) {
    return (
        <svg {...props} width="40" height="40" viewBox="0 0 40 40">
            <path d="M23.5 24.2V21.6H34V29.4C34 30.8083 32.7422 32 31.375 32H8.625C7.20312 32 6 30.8083 6 29.4V21.6H16.5V24.2C16.5 24.6875 16.8828 25.0667 17.375 25.0667H22.625C23.0625 25.0667 23.5 24.6875 23.5 24.2ZM31.375 11.2C32.7422 11.2 34 12.4458 34 13.8V19.8667H6V13.8C6 12.4458 7.20312 11.2 8.625 11.2H13V8.6C13 7.24583 14.2031 6 15.625 6H24.375C25.7422 6 27 7.24583 27 8.6V11.2H31.375ZM24.375 11.2V8.6H15.625V11.2H24.375Z" />
        </svg>
    );
}
